module.exports = __webpack_public_path__ + "static/img/integate-banner4.945bc07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/integate-banner4.png
// module id = aj6R
// module chunks = 134